export default __webpack_public_path__ + "static/lgbtq-allgay-atlantis-34fdf0fb1a3b054442dab67d20c72854.png";